import { ROLES } from 'constants/userConstants';

export const maxFieldLength = 100;
export const employeeRequiredFields = ['firstName', 'lastName', 'role'];
export const employeeRoles = [ROLES.ADMIN];
